import React from 'react';
import './DeleteConfirmationModal.css';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, itemName }) => {
    if (!isOpen) return null;

    return (
        <div className="delete-modal-overlay" onClick={onClose}>
            <div className="delete-modal" onClick={e => e.stopPropagation()}>
                <div className="delete-icon-wrapper">
                    <span className="delete-icon">⚠️</span>
                </div>
                <h3 className="delete-title">Delete Saved Item?</h3>
                <p className="delete-message">
                    Are you sure you want to delete <strong>{itemName}</strong>? This action cannot be undone.
                </p>
                <div className="delete-actions">
                    <button className="btn-cancel" onClick={onClose}>Cancel</button>
                    <button className="btn-confirm-delete" onClick={() => { onConfirm(); onClose(); }}>Delete</button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmationModal;
